export default __webpack_public_path__ + "static/media/companyLogo.98ebc9e6.svg";